import {Injectable} from '@angular/core';
import ILanguage = Data.Language.ILanguage;

@Injectable({ providedIn: 'root' })
export class FertilizationGridService {
  public formatNumericValue(decimalPlaces: number, language: ILanguage): (item: any, value: any) => string {
    return (_: any, value: any) => {
      let valueForCalculations = value;
      if (value.includes(',')) {
        valueForCalculations = value.replace(',', '.');
      }
      const numberValue = Number(valueForCalculations);
      if (isNaN(numberValue) || numberValue === 0) {
        return '';
      }
      // Use browser's locale or specified locale
      return new Intl.NumberFormat(language.Key, {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
      }).format(numberValue);
    };
  }
}
